<template>
  <v-container fluid pa-0>
    <a-search
      v-model="search"
      :title="$t('users')"
      icon="supervised_user_circle"
    />
    <v-layout row wrap justify-center style="margin-top: -65px">
      <v-card class="flex xs11">
        <v-toolbar color="grey6 elevation-0">
          <v-btn color="primary" to="/users/new" v-if="can.add">{{
            $t("new_record")
          }}</v-btn>
          <v-spacer />
          <v-btn
            flat
            icon
            class="mx-0"
            @click="getData"
            :loading="loading"
            color="grey darken-2"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-data-table
          ref="tbl"
          item-key="id"
          :items="items"
          :search="search"
          :headers="headers"
          :loading="loading"
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{ item }">
            <td class="py-2">
              <v-avatar
                dark
                size="30px"
                :color="item.active ? 'primary' : 'secondary'"
              >
                <img :src="item.image" />
              </v-avatar>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.roles | rolesName }}</td>
            <td>{{ item.branch.name }}</td>
            <td>{{ item.branch.code }}</td>
            <td v-if="can.any">
              <!-- <v-btn
                flat
                icon
                v-if="can.view"
                class="mx-0 px-0"
                color="grey darken-1"
                :to="`/users/${item.id}`"
              >
                <v-icon>launch</v-icon>
              </v-btn> -->
              <v-btn
                icon
                small
                flat
                class="ma-0"
                color="grey darken-1"
                @click="lock(item)"
                v-if="can.edit && item.id != current_user.user.id"
              >
                <v-icon>{{
                  item.active ? "mdi-lock-open-variant" : "lock"
                }}</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                flat
                class="ma-0"
                color="grey darken-1"
                :to="`/users/edit/${item.id}`"
                v-if="can.edit && item.id != current_user.user.id"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                icon
                small
                flat
                class="ma-0"
                color="grey darken-1"
                @click="showDelete(item)"
                v-if="can.delete && item.id != current_user.user.id"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-layout>
  </v-container>
</template> 

<script>
import { mapGetters } from "vuex";
export default {
  name: "users",
  data: () => ({
    items: [],
    search: "",
    loading: true,
  }),
  computed: {
    ...mapGetters("AuthModule", { current_user: "current_user" }),
    can() {
      return {
        add: this.userCan("add_users"),
        view: this.userCan("view_users"),
        edit: this.userCan("edit_users"),
        delete: this.userCan("delete_users"),
        any:
          this.userCan("edit_users") ||
          this.userCan("view_users") ||
          this.userCan("delete_users"),
      };
    },
    headers() {
      let items = [
        { text: this.$t("profile"), sortable: false, width: "40" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("roles"), value: "roles.name" },
        { text: this.$t("branch"), value: "branch.name" },
        { text: this.$t("branch_code"), value: "branch.code", width: 60 },
      ];
      if (this.can.any) {
        items.push({
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
          width: 150,
        });
      }
      return items;
    },
  },
  filters: {
    rolesName(roles) {
      let a = "";
      roles.map((role) => {
        a = a + role.name + ", ";
      });
      return a;
    },
  },
  methods: {
    setEditUser(user) {
      this.editUser = { ...user, password: "default" };
    },

    printTable(excel) {
      let data = {
        headers: [
          { text: this.$t("user"), value: "name" },
          { text: this.$t("email"), value: "email" },
          {
            text: this.$t("roles"),
            value: "roles.name",
            filter: this.getRoleName,
          },
        ],
        items: this.$refs.tbl.filteredItems,
        title: this.$t("users"),
      };
      if (excel) return this.xl_tables(data, "users", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },

    showDelete(item) {
      let vm = this;
      let index = this.items.indexOf(item);
      // let ids = items.map(a => a.id);
      this.$alert("users/" + item.id).then(function () {
        vm.items.splice(index, 1); //remove items
      });
    },

    lock(item) {
      this.axios
        .post("lock", { id: item.id })
        .then(() => {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: item.active
              ? "User Account Locked Successfully."
              : "User Account Unlocked Successfully.",
            stateType: "success",
            show: true,
          });
          this.getData();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getData() {
      this.loading = true;
      this.axios
        .get("users")
        .then((resp) => {
          this.items = resp.data;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.getData();
  },
};
</script>
 
